export default "__VITE_ASSET__BK2SX3q1__"